import { useState } from "react";
import buildRepositoryValidationErrors from "../logic/repositoryValidationErrors";
const useRepositoryFormErrors = (knownFields) => {
  const [formError, setFormError] = useState(void 0);
  const clearFormError = () => setFormError(void 0);
  const applyBackendErrors = (error, setErrors) => {
    var _a, _b;
    const backendErrors = (_b = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.body) == null ? void 0 : _b.errors;
    if (!backendErrors || typeof backendErrors !== "object") {
      return;
    }
    const { fieldErrors, generalError } = buildRepositoryValidationErrors(backendErrors, knownFields);
    setErrors(fieldErrors);
    setFormError(generalError);
  };
  return { formError, clearFormError, applyBackendErrors };
};
export default useRepositoryFormErrors;
